import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Fade, Link, Modal, Typography, useTheme } from '@mui/material';
import { ContentCopy, Description } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { setVisibility } from '../../store/actions/referralcodes-actions';

const ReferralCodeDisplay = () => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const isModalOpen = useSelector((state) => state.referralcode.isModalOpen);
    const referralCode = useSelector((state) => state.auth.user.account?.referralCode);

    const handleSelectCode = () => {};

    const handleCloseModal = () => {
        dispatch(setVisibility(false));
    };

    const handleCopy = (event, referralCode) => {
        navigator.clipboard.writeText(referralCode);
    };

    return (
        <Modal
            sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
            open={isModalOpen}
            onClose={handleCloseModal}
            closeAfterTransition
        >
            <Fade in={isModalOpen}>
                <Box
                    sx={{
                        display: 'inline-block',
                        alignItems: 'center',
                        justifyContent: 'center',
                        maxWidth: 480,
                        backgroundColor: 'white',
                        padding: 1,
                        margin: 1,
                    }}
                >
                    <List dense>
                        <ListItem onClick={handleSelectCode.bind(this)} sx={{ minWidth: 100 }}>
                            <Box sx={{ justifyContent: 'center' }}>
                                <ListItemText
                                    sx={{
                                        fontWeight: 'bold',
                                        color: theme.palette.specifics.accountNavBarItemIconColor,
                                    }}
                                    primary={
                                        <Typography
                                            sx={{
                                                display: 'inline',
                                                fontWeight: 'bold',
                                            }}
                                            component="span"
                                        >
                                            Referral Code
                                        </Typography>
                                    }
                                />
                                <ListItemText
                                    sx={{
                                        maxWidth: 150,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 1,
                                        WebkitBoxOrient: 'vertical',
                                    }}
                                    primary={referralCode}
                                />
                            </Box>
                            <Link
                                component="button"
                                sx={{ paddingLeft: 1 }}
                                onClick={(e) => {
                                    handleCopy(e, referralCode);
                                }}
                            >
                                <ContentCopy sx={{ width: 25, height: 25 }}>
                                    <Description
                                        sx={{
                                            fontWeight: 'bold',
                                            color: theme.palette.specifics.accountNavBarItemIconColor,
                                        }}
                                    />
                                </ContentCopy>
                            </Link>
                        </ListItem>
                    </List>
                </Box>
            </Fade>
        </Modal>
    );
};

export default ReferralCodeDisplay;
